import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const BUYER_HAPPY = 'BUYER_HAPPY';
export const BUYER_SAD = 'BUYER_SAD';
export const SELLER_HAPPY = 'SELLER_HAPPY';
export const SELLER_SAD = 'SELLER_SAD';

const feedbackTypes = [BUYER_HAPPY, BUYER_SAD, SELLER_HAPPY, SELLER_SAD];

const urlForType = type => {
    switch (type) {
        case BUYER_HAPPY:
            return 'https://goo.gl/forms/MsYTOPPIMcU0GNgB3';
        case BUYER_SAD:
            return 'https://goo.gl/forms/hCZFnFxXWTt2SUVF3';
        case SELLER_HAPPY:
            return 'https://goo.gl/forms/Fr8lKdltindh6Gd43';
        case SELLER_SAD:
            return 'https://goo.gl/forms/odMeiCOMk5KRuR4w2';
        default:
            throw new Error(`type ${type} not among ${feedbackTypes}`);
    }
};

const FeedbackLink = ({
    type,
    text = 'Hvordan fungerte FINN Trygg betaling for deg?',
    className,
}) => (
    <div className="mtl">
        <a
            href={urlForType(type)}
            className={classNames(className)}
            target="_blank"
            rel="noopener"
        >
            {text}
        </a>
    </div>
);

FeedbackLink.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.oneOf(feedbackTypes).isRequired,
};

export default FeedbackLink;



// WEBPACK FOOTER //
// ./safeTrade/feedbackLink.jsx